import _ from 'lodash'
import sk from './sk'
import { vsprintf } from 'sprintf-js'

const messages: any = sk

export default {
  message (key: string, defaultMessageOrObjectArgs?: any, defaultMessageParam?: string) {
    const defaultMessage = _.isString(defaultMessageOrObjectArgs) ? defaultMessageOrObjectArgs : defaultMessageParam
    let message = messages[key] || (defaultMessage ? (messages[defaultMessage] || defaultMessage) : key)
    if (_.isArray(defaultMessageOrObjectArgs)) {
      message = vsprintf(message, defaultMessageOrObjectArgs)
    }
    return message
  }
}
